<template>
  <div class="product-item">
    <bg-intro :bg="bg" class="bg-wrapper"></bg-intro>

    <div class="achievement">
      <div class="achievementWal">
        <h3>低码率声码器芯片PCV450A</h3>
        <div class="achievementWal_tit">
          PCV450A搭载了磐钴智能的低码率语音压缩算法，可在450/700/1200/2400bps
          速率下合成出高质量的语音，语音主观质量在1.2K，2.4K码率下评分MOS≥3.0，并可提供450和700两种低码率，在14000bits信道容量下，一次可传输最长31秒语音。
        </div>
        <div class="achievementWal_tit">
          PCV450A采用 UART 接口与 MCU 连接通信，用户可通过 UART
          接口实现语音编码数据的读出和写入，从输入语音到压缩完成仅需200毫秒，且支持终端与终端、终端与平台、平台与终端的语音互通功能。芯片尺寸仅有6*6mm，开发简单，应用成熟，特别适合窄带卫星物联网通信产品使用。
        </div>
        <div class="productfeature">
          <div class="productfeature_tit">产品特性：</div>
          <ul>
            <li>数据格式：8N1；</li>
            <li>CU接口：UART/USB；</li>
            <li>电源电压：2.6至3.6 V；</li>
            <li>封装：QFN-48，尺寸6*6mm；</li>
            <li>温度范围：-40至+105 ℃；</li>
            <li>波特率：115200bps~1Mbps；</li>
            <li>支持码率：450/700/1200/2400bps ；</li>
            <li>低功耗模式：睡眠、深睡眠、待机模式；</li>
          </ul>
        </div>
        <div class="abs_xinpian">
          <div class="xinpianImg">
            <img src="../../assets/product/xinpian.png" alt="PCV4XA" />
          </div>
          <div class="xinpianTit">PCV4XA</div>
          <div class="xiang"></div>
          <!-- https://back.openc.beidousdk.com/api/console/files/material/other/voice-chip-specification.pdf -->
          <div class="download" @click="downLoadTemplate">
            <img class="pdf" src="../../assets/product/pdf.png" alt="PCV4XA" />
            <span>规格书下载</span>
          </div>
        </div>
      </div>
    </div>

    <product2></product2>
    <div class="boxMd">
      <div class="boxWal">
        <h3>不同等级的北斗三号民用卡通信语音长度</h3>
        <div class="wrapperTable">
          <img class="table" src="../../assets/product/table.png" alt="table" />
        </div>
      </div>
    </div>
    <div class="form-container">
      <h3>低码率声码器芯片样品申请表单填写</h3>
      <div class="form-content">
        <el-form :model="form" :rules="custom" ref="custom" label-position="top">
          <el-form-item label="联系姓名" prop="fullName">
            <el-input v-model="form.fullName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入您的单位名称"></el-input>
          </el-form-item>
          <el-form-item label="联络电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper">
          <button @click="submitCustom">提 交</button>
        </div>
      </div>
    </div>
    <highlight :highlightsData="highlightData"></highlight>

    <div class="brief-wrapper">
      <h3>关键技术</h3>
      <brief :briefData="briefData[0]" :isReverse="true"></brief>
      <brief :briefData="briefData[1]" :isReverse="false"></brief>
      <brief :briefData="briefData[2]" :isReverse="true"></brief>
    </div>
    <!-- <product title="系列产品"></product> -->
    <beDevelop></beDevelop>
  </div>
</template>

<script>
import axios from 'axios';
import bgIntro from '@/components/common/product/bgIntro.vue';
import field from '@/components/common/solution/field.vue';
import highlight from '@/components/common/solution/highlight.vue';
import brief from '@/components/common/solution/brief.vue';
import product from '@/components/common/solution/product.vue';
import product2 from '@/components/common/solution/product2.vue';
import beDevelop from '@/components/common/beDevelop.vue';
import config from '@/config';
import { validatePhone, validateFullName, validateCompany } from '@/utils/validate';
export default {
  inject: ['reload'],
  metaInfo: {
    title: '极低码率声码器芯片——PCV4XA：专为窄带卫星物联网&低速率信道场景设计',
  },
  data() {
    return {
      baseUrl: config.baseUrl,
      bg: require('../../assets/product/banner.png'),
      form: {
        fullName: '',
        phone: '',
        companyName: '',
      },
      custom: {
        fullName: [{ required: true, trigger: 'blur', validator: validateFullName }],
        companyName: [{ required: true, trigger: 'blur', validator: validateCompany }],
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
      },

      highlightData: {
        title: '服务优势',
        items: [
          {
            id: 'h1',
            title: '极致压缩比',
            intro: '采样率8kHz， 码率是450bps， 使用北斗三号五级卡（1750字节）情况下，最长能传输31秒语音。',
            imgSrc: require('../../assets/solution/yyys-fuzb1.webp'),
            color: '#EFA65E',
          },
          {
            id: 'h2',
            title: '超高压缩效率',
            intro: '从语音输入到压缩完成，整个过程仅需200毫秒。',
            imgSrc: require('../../assets/solution/yyys-fuzb2.webp'),
            color: '#63B59F',
          },
          {
            id: 'h3',
            title: '高保真效果',
            intro: '集成学习的波速形成语音增强算法，能清晰分辨男声或女声，分辨使用者身份。',
            imgSrc: require('../../assets/solution/yyys-fuzb3.webp'),
            color: '#4173FB',
          },
        ],
      },
      briefData: [
        {
          title: '语音过渡段清/浊音判决技术',
          imgSrc: require('../../assets/solution/guanjian1.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '平板应用app支持全国卫星/标准离线地图下载，储存在平板电脑本地；  ',
              intro:
                '基于上采样的基音周期估计算法，过渡段清/浊音判决以及基于过渡段的非对称窗LPC分析方法，有效提升语音质量。',
            },
          ],
        },
        {
          title: '波束形成与深度学习相结合的语音增强算法',
          imgSrc: require('../../assets/solution/guanjian2.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '复高斯混合模型估计时频掩蔽和方向矢量',
              intro: '利用复高斯混合模型估计时频掩蔽和方向矢量的波束形成方法，有效去除环境噪声，增强语音效果。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
        {
          title: '低码率环境高效可靠语音传输协议优化技术',
          imgSrc: require('../../assets/solution/guanjian3.webp'),
          introItems: [
            {
              id: 'intro1',
              intro:
                '基于编码冗余的抗长延时语音传输协议；自适应信道速率的动态分包算法；基于遗传算法的链路资源智能调度策略。有效支持丢包重传，支持用户动态调整，提高传输效率。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
      ],
      practiceData: {
        title: '应用场景',
        items: [
          {
            id: '战术通信指挥调度',
            intro: '战术通信指挥调度',
            imgSrc: require('../../assets/product/yingyong1.webp'),
          },
          {
            id: '电力巡检应急通信',
            intro: '电力巡检应急通信',
            imgSrc: require('../../assets/product/yingyong2.webp'),
          },
          {
            id: '国家地质公园卫星语音一键呼叫',
            intro: '国家地质公园卫星语音一键呼叫',
            imgSrc: require('../../assets/product/yingyong3.webp'),
          },
          {
            id: '森林消防应急位置追踪',
            intro: '森林消防应急位置追踪',
            imgSrc: require('../../assets/product/yingyong4.webp'),
          },
        ],
      },
    };
  },

  components: {
    bgIntro,
    field,
    highlight,
    brief,
    product,
    product2,
    beDevelop,
  },
  methods: {
    submitCustom() {
      this.$refs.custom.validate(async (valid) => {
        if (valid) {
          try {
            const res = await axios({
              baseURL: config.baseUrl,
              url: '/api/console/forms/voice-chip-application',
              method: 'post',
              params: {
                Authorization: '1213',
                ...this.form,
              },
            });
            console.log(res);
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '提交成功',
              });
              this.form = {
                fullName: '',
                phone: '',
                companyName: '',
              };
              this.reload();
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    // 下载模板
    downLoadTemplate() {
      let downloadUrl = `https://back.openc.beidousdk.com/api/console/files/material/other/voice-chip-specification.pdf`;
      window.open(downloadUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  width: 100%;

  .achievement {
    background: #f6f7f8;

    .achievementWal {
      width: 1200px;
      margin: 0 auto;
      padding-top: 70px;
      padding-bottom: 100px;
      position: relative;
    }

    h3 {
      text-align: center;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0d0e24;
      line-height: 30px;
      padding-bottom: 45px;
    }

    .achievementWal_tit {
      text-indent: 2em;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #0d0e24;
      line-height: 32px;
      padding: 0 50px;
      box-sizing: border-box;
    }

    .productfeature {
      margin-top: 130px;
      padding-left: 110px;
      // position: relative;

      .productfeature_tit {
        font-size: 23px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0d0e24;
        margin-left: 25px;
      }

      li {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0d0e24;
        line-height: 36px;
      }
    }

    .abs_xinpian {
      position: absolute;
      left: 650px;
      bottom: 70px;
      width: 402px;
      height: 402px;
      border: 1px dashed #b6b9ba;
      display: flex;
      flex-direction: column;
      align-items: center;

      .xinpianImg {
        margin-top: 42px;
        width: 100%;
        display: flex;
        justify-content: center;

        img {
          width: 143px;
          height: 145px;
        }
      }

      .xinpianTit {
        margin-top: 10px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0d0e24;
      }

      .xiang {
        margin-top: 45px;
        width: 241px;
        height: 1px;
        border-top: 1px dashed #b6b9ba;
      }

      .download {
        cursor: pointer;
        margin-top: 55px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #db251f;

        .pdf {
          width: 20px;
          height: 24px;
          margin-right: 5px;
        }
      }
    }
  }

  .video-wrapper {
    width: 1200px;
    margin: 70px auto;

    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-bottom: 60px;
    }

    .wrapperList {
      width: 100%;

      .wrapperItem {
        width: 100%;
        display: flex;

        .wrapperMd {
          width: 600px;
          height: 320px;
          background: #f6f7f8;
        }

        .wrapperf {
          display: flex;
          flex-direction: column;
          align-items: center;

          .wrapperf_tit1 {
            margin-top: 105px;
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #0d0e24;
          }

          a {
            text-decoration: none;
          }

          .wrapperf_tit2 {
            cursor: pointer;
            margin-top: 40px;
            width: 176px;
            height: 40px;
            border: 1px solid #4173fb;
            border-radius: 20px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #4173fb;
            text-align: center;
            line-height: 40px;
          }
        }
      }
    }
  }

  .boxMd {
    background: #f6f7f8;
    position: relative;
    padding: 70px 0;

    .boxWal {
      width: 1200px;
      margin: 0 auto;
      position: relative;
    }

    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-bottom: 60px;
    }
  }

  .wrapperTable {
    display: flex;
    align-items: center;

    .table {
      width: 1200px;
      height: 387px;
    }
  }

  .brief-wrapper {
    margin-top: 70px;

    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      text-align: center;
    }
  }

  .form-container {
    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-top: 50px;
      margin-bottom: 50px;
    }

    width: 1000px;
    margin: 0 auto;

    .form-content {
      width: 800px;
      margin: 0 auto;

      &::v-deep {
        .el-form-item__label {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }

      .btn-wrapper {
        text-align: left;
        margin-top: 60px;
        margin-bottom: 60px;

        button {
          width: 256px;
          height: 46px;
          background: #4173fb;
          border-radius: 4px;
          cursor: pointer;
          outline: none;
          border: none;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
</style>